import { render, staticRenderFns } from "./SystemPermissionManageByRentalcompany.vue?vue&type=template&id=0b50ac68&scoped=true"
import script from "./SystemPermissionManageByRentalcompany.vue?vue&type=script&lang=js"
export * from "./SystemPermissionManageByRentalcompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50ac68",
  null
  
)

export default component.exports